import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getRegulationsStagesPlanWorksMaterials(companyId, regulationId, stageId, planWorkId) {
	return dataTransferWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS].getRegulationsStagesPlanWorksMaterials,
		{
			urlParams: {
				companyId: companyId,
				regulationId,
				stageId,
				planWorkId,
			},
		},
	)
}
function getRegulationsStagesPlanWorksMaterialPreview(companyId, regulationId, stageId, planWorkId, materialId) {
	return dataTransferWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS].getRegulationsStagesPlanWorksMaterialPreview,
		{
			urlParams: {
				companyId: companyId,
				regulationId,
				stageId,
				planWorkId,
				materialId,
			},
		},
	)
}
function getRegulationsStagesPlanWorksMaterialPopup(companyId, regulationId, stageId, planWorkId, materialId) {
	return dataTransferWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS].getRegulationsStagesPlanWorksMaterialPopup,
		{
			urlParams: {
				companyId: companyId,
				regulationId,
				stageId,
				planWorkId,
				materialId,
			},
		},
	)
}

function createRegulationsStagesPlanWorksMaterial(companyId, regulationId, stageId, planWorkId, data) {
	return dataTransferWrap(ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS].createRegulationsStagesPlanWorksMaterial, {
		urlParams: {
			companyId,
			regulationId,
			stageId,
			planWorkId,
		},
		...data,
	})
}

function getRegulationsStagesPlanWorksMaterial(companyId, regulationId, stageId, planWorkId, materialId) {
	return dataTransferWrap(ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS].getRegulationsStagesPlanWorksMaterial, {
		urlParams: {
			companyId,
			regulationId,
			stageId,
			planWorkId,
			materialId,
		},
	})
}

function patchRegulationsStagesPlanWorksMaterial(companyId, regulationId, stageId, planWorkId, materialId, data) {
	return dataTransferWrap(ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS].patchRegulationsStagesPlanWorksMaterial, {
		urlParams: {
			companyId,
			regulationId,
			stageId,
			planWorkId,
			materialId,
		},
		...data,
	})
}

function putRegulationsStagesPlanWorksMaterial(companyId, regulationId, stageId, planWorkId, materialId, data) {
	return dataTransferWrap(ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS].putRegulationsStagesPlanWorksMaterial, {
		urlParams: {
			companyId,
			regulationId,
			stageId,
			planWorkId,
			materialId,
		},
		...data,
	})
}

function deleteRegulationsStagesPlanWorksMaterial(companyId, regulationId, stageId, planWorkId, materialId) {
	return dataTransferWrap(ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS].deleteRegulationsStagesPlanWorksMaterial, {
		urlParams: {
			companyId,
			regulationId,
			stageId,
			planWorkId,
			materialId,
		},
	})
}

export default {
	getRegulationsStagesPlanWorksMaterials,
	getRegulationsStagesPlanWorksMaterialPopup,
	getRegulationsStagesPlanWorksMaterialPreview,
	getRegulationsStagesPlanWorksMaterial,
	patchRegulationsStagesPlanWorksMaterial,
	putRegulationsStagesPlanWorksMaterial,
	createRegulationsStagesPlanWorksMaterial,
	deleteRegulationsStagesPlanWorksMaterial,
}
